import { Component, OnInit, Input, OnChanges, OnDestroy, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { Destroy, SortExpression, tr, Key } from '@kpd/framework-ngx';
import { Permission } from 'app/shared/models/permission';
import { SortEvent } from 'primeng/components/common/sortevent';
import { PermissionService } from 'app/shared/services/permission.service';
import { TableController } from 'app/shared/utils/table-controller';
import { PermissionFacade } from 'app/shared/services/facades/permission.facade';

@Component({
  selector: 'app-permission-details-roles',
  templateUrl: './permission-details-roles.component.html',
})
export class PermissionDetailsRolesComponent extends TableController implements OnInit, OnChanges, OnDestroy {
  @Input()
  permission: Permission;
  @Destroy()
  destroy$: any;
  readOnlyMode = true;
  selectedKeys: Key<string>[] = [];
  selection = [];
  sortExpression: SortExpression;
  columnsConfig = this.createColumnsConfig();
  @Output()
  roleCountChanged = new EventEmitter<number>();

  constructor(private permissionFacade: PermissionFacade, private permissionService: PermissionService) {
    super();
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.permission) {
      this.selectedKeys = [];
      this.selection = [];
      if (
        changes.permission.currentValue &&
        (changes.permission.currentValue as Permission).key &&
        (changes.permission.currentValue as Permission).key.isDefined()
      ) {
        this.loadPermissionRoles((changes.permission.currentValue as Permission).key.id);
      }
    }
  }

  loadPermissionRoles(id: string): void {
    this.permissionFacade.detailLoadingStarted();
    this.permissionService.getRoles(id).subscribe(
      (roles) => {
        this.items = roles;
        this.roleCountChanged.emit(roles.length);
        this.permissionFacade.detailLoadingFinished();
      },
      () => {
        this.permissionFacade.detailLoadingFinished();
      },
    );
  }

  onSort(event: SortEvent): void {
    this.sortExpression = new SortExpression();
    this.sortExpression.fieldName = event.field as string;
    this.sortExpression.sortOrder = event.order as number;
  }

  createColumnsConfig(): any[] {
    return [{ field: 'name', header: tr('Name') }];
  }

  // tslint:disable-next-line:no-unused-expression
  ngOnDestroy(): void {}
}
